(function () {
  const loadMore = document.getElementById('load-more');

  if (!loadMore) return;

  let paged = loadMore.getAttribute('data-paged');
  const maxPages = loadMore.getAttribute('data-max-pages');
  const postType = loadMore.getAttribute('data-post-type');

  loadMore.addEventListener('click', function (event) {
    event.preventDefault();

    fetch(load_more_data.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        nonce: load_more_data.nonce,
        locale: load_more_data.locale,
        paged: paged,
        postType: postType,
        action: 'more_posts'
      })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.text();
      })
      .then(response => {
        paged++;
        document.getElementById('article-list-archive').insertAdjacentHTML('beforeend', response);

        if (paged == maxPages) {
          loadMore.remove();
        } else {
          loadMore.disabled = false;
        }

        const loadMoreEvent = new CustomEvent('loadMoreTriggered', {
          detail: {
            type: postType,
          }
        });
    
        document.dispatchEvent(loadMoreEvent);
      })
      .catch(error => {
        console.error('Error:', error);
        loadMore.disabled = false;
      });

    loadMore.disabled = true;
  });
})();